function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href]:not([style*='display: none']), button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):not(.contact-ref-x):enabled, select:enabled, textarea:enabled, object, iframe, div[tabindex='0']"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container, lastElement = false) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = lastElement ? lastElement : elements[elements.length - 1];

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function closeByFocusOut(container, trigger) {
  const handleTabKey = (event) => {
    if (event.key.toUpperCase() === "TAB") {
      if (!container.contains(document.activeElement)) {
        trigger();
        document.removeEventListener("keyup", handleTabKey);
      }
    }
  }
  document.addEventListener("keyup", handleTabKey);
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('video-play-pause').forEach((controller) => controller.handleControlAttr(controller, false));
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function customPagination(wrapper, items, itemPerPage, currentPage, pageURL, caretIcon, customerId) {
  const totalPage = Math.ceil(items / itemPerPage);
  if(!(totalPage > 1)) {
    if (!(currentPage > 1)) {
      wrapper.innerHTML = '';
    }
    return;
  }
  currentPage = currentPage > totalPage ? 1 : currentPage;

  function getPaginatePart(start, end, portion) {
    let part = [];
    if ((start - end) === 2) {
      part = portion === 'first' ? [start - 1] : [end + 1];
    } else if ((start - end) === 3) {
      part = portion === 'first' ? [start - 2, start - 1] : [end + 1, end + 2];
    } else if ((start - end) >= 4) {
      part = portion === 'first' ? ['...', start - 2, start - 1] : [end + 1, end + 2, '...'];
    }
    return part;
  }
  function paginateParts(currentPage, totalPage) {
    let parts = [
      ...getPaginatePart(currentPage, 1, 'first'),
      currentPage,
      ...getPaginatePart(totalPage, currentPage)
    ];
    currentPage !== 1 && parts.unshift(1);
    currentPage !== totalPage && parts.push(totalPage);
    currentPage !== parts[0] && parts.unshift('<');
    totalPage !== currentPage && parts.push('>');
    return parts;
  }
  let paginateNumbers = paginateParts(currentPage, totalPage);
  const addLink =(page)=> {
    let link;
    if(typeof page === 'number') {
      if (page !== currentPage) {
        link = `<a class="pagination__item link" href="${pageURL}?${customerId ? 'id=' + customerId + '&' : ''}showPage=${page}">${page}<a/>`;
      } else if (currentPage === page ) {
        link = `<a class="pagination__item pagination__item--current link" href="${pageURL}?${customerId ? 'id=' + customerId + '&' : ''}showPage=${page}">${page}<a/>`;
      }
    } else {
      if (page === '<') {
        link = `<a href="${pageURL}?${customerId ? 'id=' + customerId + '&' : ''}showPage=${currentPage-1}" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce">
                  ${caretIcon}
                </a>`;
      } else if (page === '>') {
        link = `<a href="${pageURL}?${customerId ? 'id=' + customerId + '&' : ''}showPage=${currentPage+1}" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce">
                  ${caretIcon}
                </a>`;
      } else {
        link = `<span class="pagination__item">${page}</span>`;
      }
    }
    return link;
  }
  wrapper.innerHTML = '';
  const addNumber = (i) => {
    const li = document.createElement('li');
    li.innerHTML = addLink(i);
    wrapper.appendChild(li);
  }
  for ( let i = 0; i < paginateNumbers.length; i++) {
    addNumber(paginateNumbers[i]);
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class KineticModal extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;

    const overlay = document.querySelector('.kinetic-modal__overlay');

    const removeModalHandler = (modal) => {
      modal.classList.remove('kinetic-modal--show');
      if (modal.classList.contains('kinetic-modal--setperspective')) {
        document.documentElement.classList.remove('kinetic-modal--perspective');
      }

      if (document.querySelector(".kinetic-modal.kinetic-modal--show")) {
        let showModalElement = document.querySelector(".kinetic-modal.kinetic-modal--show");
        trapFocus(showModalElement, showModalElement.querySelector("button"));
      } else {
        removeTrapFocus(button);
      }
    };

    let modal = document.querySelector(this.getAttribute('data-kinetic-modal'));
    const closeElems = modal.querySelectorAll('[data-dismiss="modal"]');

    const focusableElements = getFocusableElements(modal);

    button.addEventListener('click', function(ev) {
      ev.preventDefault();

      modal.classList.add('kinetic-modal--show');
      modal.escHandler = function (event) {
        if (event.key.toUpperCase() === "ESCAPE") {
          event.stopImmediatePropagation();
          closeModal();
        }
      };
      modal.addEventListener('keydown', modal.escHandler);

      modal.setAttribute('tabindex', '0');
      trapFocus(modal);
      overlay.removeEventListener('click', () => { removeModalHandler(modal)} );
      overlay.addEventListener('click', () => { removeModalHandler(modal)} );

      if (button.classList.contains('kinetic-modal--setperspective')) {
        button.addEventListener('transitionend', () => {
          document.documentElement.classList.add('kinetic-modal--perspective');
        }, {once: true});
      }
    });

    closeElems.forEach((closeElem) => {
      closeElem.addEventListener('click', function(ev) {
        ev.stopPropagation();
        closeModal();
      });
    });

    function closeModal() {
      removeModalHandler(modal);
      modal.classList.remove("kinetic-modal--show");
      modal.setAttribute('tabindex', "-1");
      removeTrapFocus(button);
      if (modal.escHandler) {
        modal.removeEventListener('keydown', modal.escHandler);
        delete modal.escHandler;
      }
    }

  }
}

customElements.define('kinetic-modal', KineticModal);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if (this.dataset.mediaType === 'video') this.loadContent(false);
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    // check slider component nested or not if nested we need to set name in parent component when we use it
    if(!this.getAttribute("name")) {
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
    } else {
      this.prevButton = this.querySelector('button[name="parent-previous"]');
      this.nextButton = this.querySelector('button[name="parent-next"]');
    }

    this.seamlessLoop = this.getAttribute("data-loop");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.seamlessLoop) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('data-end', 'true');
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.sliderItemsToShow.length - 1,
          currentElement: this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        }}));
      } else {
        this.prevButton.removeAttribute('data-end');
      }
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: 1,
          currentElement: this.sliderItemsToShow[1]
        }}));
        this.nextButton.setAttribute('data-end', 'true');
      } else {
        this.nextButton.removeAttribute('data-end');
      }
    } else {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element?.offsetLeft + element?.clientWidth <= lastVisibleSlide && element?.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (!event.currentTarget.dataset.end) {
      this.slideScrollPosition = event.currentTarget.name.includes('next') ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    } else {
      this.slideScrollPosition = (
        event.currentTarget.name === 'next' ? 0 : this.slider.scrollWidth - this.slider.clientWidth
      );
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    this.ignoreFocus = this.getAttribute("data-ignore-focus");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', base.utils.debounce(this.setSlideVisibility.bind(this)));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    if (!this.ignoreFocus) {
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
    }

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    event.stopPropagation();
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setTitleSelected(item, isSelected) {
    const id = item.id;
    const matchingElement = document.querySelector(`[data-visible-image-id="${id}"]`);
    if (matchingElement) {
      matchingElement.classList.toggle('selected', isSelected);
    }
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      const isCurrent = index === this.currentPage - 1 || this.isSlideVisible(item); 
      const tabIndex = isCurrent ? '0' : '-1';
      if (button) button.setAttribute('tabindex', tabIndex);

      item.setAttribute('aria-hidden', (!isCurrent).toString());
      !item.dataset?.notFocusable && item.setAttribute('tabindex', tabIndex);
      const focusableElements = getFocusableElements(item);
      focusableElements.forEach((element) => element.setAttribute('tabindex', tabIndex));

      // apply the selected class to the corresponding title
      if (item.classList.contains("anniversary-slider")) {
        this.setTitleSelected(item, isCurrent);
      }

       // if slideshow item is a video then play when it is visible and pause when it is out of the view.
      const slideVideo = item.querySelector('video');
      if (slideVideo) {
        const videoControl = slideVideo.parentElement?.querySelector('video-control');
        if (!videoControl) return;
        if (isCurrent) {
          const play = !slideVideo.dataset.stateUpdated || slideVideo.dataset.stateUpdated === 'play';
          if (play && slideVideo.readyState !== 0) {
            slideVideo.currentTime = 0
            slideVideo.play();
          }
          videoControl?.visibleControl(play ? 'play' : '');
        } else if (!slideVideo.paused || slideVideo.dataset.stateUpdated === 'pause') {
          slideVideo.pause();
          videoControl?.classList?.remove('playing');
          videoControl?.classList?.add('paused');
        }
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (window.location.href.includes('preview_key')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.currentVariant.id);
      return window.location.href = url.toString();
    }
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        const selectedElement = html.querySelector('product-form.product-form__main button');
        const oldAddButton = document.querySelector('product-form.product-form__main button');
        oldAddButton.parentNode.replaceChild(selectedElement, oldAddButton);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector('[id^="accordion__"]');
    if (this.accordion) {
      this.accordion.addEventListener("click", this.onButtonClick.bind(this));
    }
  }

  closeAccordionItems(skipItem) {
    const accordionItems = this.accordion.querySelectorAll('button[aria-expanded="true"]');
    accordionItems.forEach((item) => {
      if (item.getAttribute('id') !== skipItem) {
        this.handleCollapse(item);
      }
    });
  }

  handleCollapse(button) {
    const textContent = button.nextElementSibling;
    if (!textContent) return;
    textContent.classList.toggle('open');
    const height = textContent.children[0].offsetHeight;
    const maxHeight = textContent.classList.contains('open') ? `${height}px` : '0px';
    button.setAttribute('aria-expanded', `${textContent.classList.contains('open') ? true : false}`);
    textContent.style.maxHeight = maxHeight;
  }

  onButtonClick(event) {
    const target = event.target.closest("button");
    if (!target) return;
    this.closeAccordionItems(target.getAttribute('id'));
    this.handleCollapse(target);
  }
}

customElements.define('custom-accordion', CustomAccordion);

document.addEventListener('DOMContentLoaded', function () {
  const socialSharing = document.querySelectorAll('.social-sharing');
  const closeShareDropdown = (element) => {
    element.classList.remove('open-social-sharing');
    element.setAttribute('aria-hidden', true);
    element.parentNode.querySelector('button').setAttribute("aria-expanded", false);
    element.querySelectorAll("[tabindex]").forEach((item) => {
      item.setAttribute('tabindex', '-1');
    });
  }

  socialSharing.forEach((item) => {
    const itemParent = item.parentNode;
    const itemSocialSharing = itemParent.querySelector('.social-sharing');
    itemParent.addEventListener('click', function () {
      if (itemSocialSharing.classList.contains('open-social-sharing')) {
        closeShareDropdown(item);
      } else {
        item.classList.add('open-social-sharing');
        itemSocialSharing.setAttribute('aria-hidden', false);
        itemSocialSharing.parentNode.querySelector('button').setAttribute("aria-expanded", true);
        item.querySelectorAll("[tabindex]").forEach((item) => {
          item.setAttribute('tabindex', '0');
        });
        closeByFocusOut(itemSocialSharing, () => {
          itemParent.click();
        });
      }
    });
  });
  window.onclick = function (e) {
    if (!e.target.parentNode?.matches('.social-sharing__container, .share, .icon__share')) {
      socialSharing.forEach((item) => {
        const itemParent = item.parentNode;
        const itemSocialSharing = itemParent.querySelector('.social-sharing');
        if (itemSocialSharing.classList.contains('open-social-sharing')) {
          closeShareDropdown(item);
        }
      });
    };
  };
});

document.addEventListener('DOMContentLoaded', function () {
  const copyText = document.querySelectorAll('.copy-to-clipboard');
  copyText.forEach(item => {
    item.addEventListener('click', function () {
      navigator.clipboard.writeText(item.value);
    });
  });
});
// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector(".header-wrapper.header-wrapper__02");
//   const headerMobile = document.querySelector(
//     ".header-wrapper.header-mobile-wrapper__02"
//   );

//   const isMobile = window.matchMedia("(max-width: 990px)").matches;

//   document.addEventListener("scroll", function () {
//     if (isMobile) {
//       if (window.scrollY > 100) {
//         headerMobile.classList.add("sticky");
//       } else {
//         headerMobile.classList.remove("sticky");
//       }
//     } else {
//       if (window.scrollY > 150) {
//         header.classList.add("sticky");
//       } else {
//         header.classList.remove("sticky");
//       }
//     }
//   });
// });

document.querySelectorAll('details.details').forEach((detail) => {
  const summary = detail.querySelector('summary');
  const content = detail.querySelector('.content');

  summary.addEventListener('click', (e) => {
    if (e.target.tagName.toLowerCase() === "a") return;
    e.preventDefault();

    if (detail.open) {
      detail.style.height = `${detail.offsetHeight}px`;
      requestAnimationFrame(() => {
        detail.style.height = `${summary.offsetHeight}px`;
      });
      summary.setAttribute('aria-expanded', false);
      detail.addEventListener(
        'transitionend',
        () => {
          detail.removeAttribute('open');
          detail.style.height = '';
        },
        { once: true }
      );
    } else {
      detail.style.height = `${summary.offsetHeight}px`;
      detail.setAttribute('open', true);
      summary.setAttribute('aria-expanded', true);
      const endHeight = `${summary.offsetHeight + content.scrollHeight}px`;

      requestAnimationFrame(() => {
        detail.style.height = endHeight;
      });

      detail.addEventListener(
        'transitionend',
        () => {
          detail.style.height = '';
        },
        { once: true }
      );
    }
  });
});

// Set up the 'read more' button on all product templates
document.addEventListener("DOMContentLoaded", () => {
  const productDescription = document.querySelector(
    "#product__description__expandable"
  );
  const loadMoreButton = document.querySelector(
    ".product__description_load_more"
  );

  if (!productDescription || !loadMoreButton) return;

  if (
    // is truncated
    productDescription.scrollHeight > productDescription.offsetHeight
  ) {
    loadMoreButton.style.display = "inline";
  }

  loadMoreButton.addEventListener("click", () => {
    productDescription.classList.toggle("open");
    loadMoreButton.querySelector(".label").textContent =
      productDescription.classList.contains("open") ? "Read Less" : "Read More";
  });
});

// Making twttr value true to prevent loading Yotpo’s Twitter JS Script. because that script load in theme if this variable value is undefined.
var twttr = true;